export type FreeCheckoutInput = {
    /**
     * Whether the form has settled on a price at all: an item is chosen, and if it sells ticket
     * types, one of those is chosen too.
     */
    hasResolvedPrice: boolean
    totalPrice: number
}

/**
 * Pure: whether this checkout is a free registration — no billing details, no payment obligation,
 * no payment provider.
 *
 * An unresolved selection is never free. A 0 total before an item (or its ticket type) is picked
 * means "not priced yet", and reading that as free would strip the billing fields off a purchase
 * that still owes them, the moment the page loads.
 */
export const isFreeRegistration = ({ hasResolvedPrice, totalPrice }: FreeCheckoutInput): boolean =>
    hasResolvedPrice && totalPrice === 0
